import { useState, useEffect } from 'react';
import { navLinks } from '@/mocks/homeData';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('section-1');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);

      const sections = navLinks.map(l => l.target);
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = document.getElementById(sections[i]);
        if (el && el.getBoundingClientRect().top <= 200) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (target: string) => {
    const el = document.getElementById(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setIsMobileOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-500 border-b ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-xl border-background-200/60 shadow-sm'
          : 'bg-white/90 backdrop-blur-xl border-background-200/40'
      }`}
    >
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          <div className="flex items-center gap-2 group">
            <a
              href="https://edugraph.nseedu.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-8 h-8 rounded-lg bg-gradient-to-br from-accent-500 to-accent-600 flex items-center justify-center breathing-glow transition-transform duration-300 group-hover:scale-110 group-hover:rotate-6"
            >
              <i className="ri-brain-line text-white text-sm" />
            </a>
            <button
              onClick={() => scrollTo('section-1')}
              className={`font-heading text-base md:text-lg font-bold tracking-tight transition-colors duration-300 text-foreground-950 cursor-pointer`}
            >
              AI云智评
            </button>
          </div>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <button
                key={link.target}
                onClick={() => scrollTo(link.target)}
                className={`relative px-3 lg:px-4 py-2 rounded-lg text-sm font-body whitespace-nowrap transition-all duration-300 cursor-pointer ${
                  activeSection === link.target
                    ? 'bg-accent-50 border border-accent-200/50 text-accent-700 font-medium scale-105'
                    : 'text-foreground-950 hover:text-accent-600 hover:bg-background-100/80'
                }`}
              >
                {link.label}
                {activeSection === link.target && (
                  <span className="absolute -bottom-0.5 left-1/2 -translate-x-1/2 w-5 h-0.5 rounded-full bg-gradient-to-r from-accent-300 to-accent-500 animate-scale-in" />
                )}
              </button>
            ))}
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-background-100/60 transition-colors cursor-pointer"
            onClick={() => setIsMobileOpen(!isMobileOpen)}
          >
            <i className={`ri-${isMobileOpen ? 'close' : 'menu'}-line text-xl text-foreground-950`} />
          </button>
        </div>
      </div>

      {isMobileOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-xl border-b border-background-200/60 shadow-sm">
          <div className="px-6 py-4 space-y-1">
            {navLinks.map((link) => (
              <button
                key={link.target}
                onClick={() => scrollTo(link.target)}
                className={`block w-full text-left px-4 py-3 rounded-lg text-sm font-body transition-colors ${
                  activeSection === link.target
                    ? 'bg-accent-50 text-accent-700 font-medium'
                    : 'text-foreground-950 hover:bg-background-100/80'
                }`}
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}